import {
    IData,
    HigherEducationModel,
    IQualification,
    IQualificationFormModel,
    CertificationModel, PostGraduationModel,
} from "../types/qualification.types";
import { Certification, HigherEducation, Qualification, } from "../../../../../domains/models/employee";
import server from "../../../../../server";
import dayjs from "dayjs";


export function viewMapper(data: IData): IQualificationFormModel {
    const {qualification} = data;
    return {
        matriculation: {
            passingYear: qualification.matriculation?.passingYear || initialFormData.matriculation.passingYear,
            percentage: qualification.matriculation?.percentage || initialFormData.matriculation.percentage,
            boardOrUniversity: qualification.matriculation?.boardOrUniversity || initialFormData.matriculation.boardOrUniversity,
            documentId: qualification.matriculation?.documentId || initialFormData.matriculation.documentId,
        },
        seniorSecondary: {
            passingYear: qualification.seniorSecondary?.passingYear || initialFormData.seniorSecondary.passingYear,
            percentage: qualification.seniorSecondary?.percentage || initialFormData.seniorSecondary.percentage,
            boardOrUniversity: qualification.seniorSecondary?.boardOrUniversity || initialFormData.seniorSecondary.boardOrUniversity,
            documentId: qualification.seniorSecondary?.documentId || initialFormData.seniorSecondary.documentId,
        },
        graduation: qualification.graduation?.length ? qualification.graduation?.map((item: HigherEducation) => ({
            passingYear: item?.passingYear || "",
            cgpa: item?.cgpa || "",
            boardOrUniversity: item?.boardOrUniversity || "",
            degreeId: item.qualificationItem?.id || "",
            degreeCode: item.qualificationItem?.code || "",
            documentId: item?.documentId || "",
        })) : initialFormData.graduation,
        postGraduation: qualification.postGraduation?.length ? qualification.postGraduation?.map((item: HigherEducation) => ({
            passingYear: item?.passingYear || "",
            cgpa: item?.cgpa || "",
            boardOrUniversity: item?.boardOrUniversity || "",
            degreeId: item.qualificationItem?.id || "",
            degreeCode: item.qualificationItem?.code || "",
            documentId: item.documentId || "",
        })) : initialFormData.postGraduation,
        certifications: qualification.certifications?.length ? qualification.certifications?.map((item: Certification) => ({
            title: item?.title || "",
            university: item?.university || "",
            certifiedBy: item?.certifiedBy || "",
            certifiedOn: item?.certifiedOn ? dayjs(item.certifiedOn, "YYYY-MM-DD") : null,
            skills: item.skills ?? [],
            documentId: item?.documentId || "",
        })) : initialFormData.certifications,
    };
}

export function modelMapper(data: IQualificationFormModel): Qualification {

    return {
        matriculation: {
            passingYear: data.matriculation.passingYear,
            percentage: data.matriculation.percentage,
            boardOrUniversity: data.matriculation.boardOrUniversity,
            documentId: data.matriculation.documentId,
        },
        seniorSecondary: {
            passingYear: data.seniorSecondary.passingYear,
            percentage: data.seniorSecondary.percentage,
            boardOrUniversity: data.seniorSecondary.boardOrUniversity,
            documentId: data.seniorSecondary.documentId,
        },
        graduation: data.graduation?.map((item: HigherEducationModel) => ({
            passingYear: item.passingYear,
            cgpa: item.cgpa,
            boardOrUniversity: item.boardOrUniversity,
            qualificationItem: {
                id: item.degreeId,
                code: item.degreeCode,
            },
            documentId: item.documentId,
        })),
        postGraduation: data.postGraduation?.map((item: HigherEducationModel) => ({
            passingYear: item.passingYear,
            cgpa: item.cgpa,
            boardOrUniversity: item.boardOrUniversity,
            qualificationItem: {
                id: item?.degreeId,
                code: item?.degreeCode,
            },
            documentId: item.documentId,
        })),
        certifications: data.certifications?.map((item: CertificationModel) => ({
            title: item.title,
            university: item.university,
            certifiedBy: item.certifiedBy,
            certifiedOn: item.certifiedOn ? item.certifiedOn.format("YYYY-MM-DD") : '',
            skills: item.skills,
            documentId: item.documentId?item.documentId:null,
        })),
    };
}



export async function fetchData(employeeId: string) {
    const qualification: Qualification = await server.employee.qualification.get(employeeId);

    return {qualification}
}

export async function fetchQualifications(): Promise<IQualification[]> {
    const qualifications = await server.settings.qualification.list();
    return qualifications.map((qualification: any) => ({
        id: qualification.id,
        code: qualification.code,
        displayName: qualification.displayName
    }));
}

export const initialData: IData = {
    qualification: {
        matriculation: {
            passingYear: "",
            percentage: "",
            boardOrUniversity: "",
            documentId: "",
        },
        seniorSecondary: {
            passingYear: "",
            percentage: "",
            boardOrUniversity: "",
            documentId: "",
        },
        graduation: [
            {
                passingYear: "",
                cgpa: "",
                boardOrUniversity: "",
                qualificationItem: {
                    id: "",
                    code: "",
                },
                documentId: "",
            }
        ],
        postGraduation: [
            {
                passingYear: "",
                cgpa: "",
                boardOrUniversity: "",
                qualificationItem: {
                    id: "",
                    code: "",
                },
                documentId: "",
            }
        ],
        certifications: [
            {
                title: "",
                university: "",
                certifiedBy: "",
                certifiedOn: "",
                skills: [],
                documentId: "",
            }
        ],
    }
}


export const initialFormData: IQualificationFormModel = {
    matriculation: {
        passingYear: "",
        percentage: "",
        boardOrUniversity: "",
        documentId: "",
    },
    seniorSecondary: {
        passingYear: "",
        percentage: "",
        boardOrUniversity: "",
        documentId: "",
    },
    graduation: [{
        passingYear: "",
        cgpa: "",
        boardOrUniversity: "",
        degreeId: "",
        degreeCode: "",
        documentId: "",
    }],
    postGraduation: [],
    certifications: [{
        title: "",
        university: "",
        certifiedBy: "",
        certifiedOn: dayjs(),
        skills: [],
        documentId: "",
    }],
}
